import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ForecastSettings } from "./types";

interface SettingsControlsProps {
  settings: ForecastSettings;
  updateSettings: (newSettings: Partial<ForecastSettings>) => void;
}

export function SettingsControls({ settings, updateSettings }: SettingsControlsProps) {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3 lg:grid-cols-6">
      <Card>
        <CardContent className="pt-6">
          <Label htmlFor="growthPercent">Growth %</Label>
          <Input
            id="growthPercent"
            type="number"
            value={settings.growthPercent}
            onChange={(e) => updateSettings({ growthPercent: parseInt(e.target.value) || 0 })}
            className="mt-1"
            min={0}
            max={100}
          />
          <p className="mt-1 text-xs text-gray-500">Monthly teen growth</p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <Label htmlFor="maxCaseload">Max Caseload</Label>
          <Input
            id="maxCaseload"
            type="number"
            value={settings.maxCaseload}
            onChange={(e) => updateSettings({ maxCaseload: parseInt(e.target.value) || 1 })}
            className="mt-1"
          />
          <p className="mt-1 text-xs text-gray-500">Teens per mentor</p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <Label htmlFor="bufferPercent">Buffer %</Label>
          <Input
            id="bufferPercent"
            type="number"
            value={settings.bufferPercent}
            onChange={(e) => updateSettings({ bufferPercent: parseInt(e.target.value) || 0 })}
            className="mt-1"
            min={0}
            max={50}
          />
          <p className="mt-1 text-xs text-gray-500">Ideal buffer</p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <Label htmlFor="malePercent">Male %</Label>
          <Input
            id="malePercent"
            type="number"
            value={settings.malePercent}
            onChange={(e) => updateSettings({ malePercent: parseInt(e.target.value) || 0 })}
            className="mt-1"
            min={0}
            max={100}
          />
          <p className="mt-1 text-xs text-gray-500">Male/Female split</p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <Label htmlFor="mentorsPerLead">Mentors per Lead</Label>
          <Input
            id="mentorsPerLead"
            type="number"
            value={settings.mentorsPerLead}
            onChange={(e) => updateSettings({ mentorsPerLead: parseInt(e.target.value) || 1 })}
            className="mt-1"
            min={1}
          />
          <p className="mt-1 text-xs text-gray-500">Lead mentor ratio</p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <Label htmlFor="mentorsPerSupervisor">Mentors per Supervisor</Label>
          <Input
            id="mentorsPerSupervisor"
            type="number"
            value={settings.mentorsPerSupervisor}
            onChange={(e) => updateSettings({ mentorsPerSupervisor: parseInt(e.target.value) || 1 })}
            className="mt-1"
            min={1}
          />
          <p className="mt-1 text-xs text-gray-500">Supervisor ratio</p>
        </CardContent>
      </Card>
    </div>
  );
}
